export const containNumberRegex = /[0-9０−９一二三四五六七八九〇]/
